module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_7.8fdf0c01.png";